import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ProductsGrid from './components/ProductsGrid';
import TestimonialSection from './components/TestimonialSection';
import TestimonialForm from './components/TestimonialForm';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-luxury-black">
      <Header />
      <HeroSection />
      <StatsSection />
      <ProductsGrid />
      <TestimonialSection />
      <TestimonialForm />
      <Footer />
    </div>
  );
};

export default HomePage;